import { CSSProperties, FC } from 'react';
import styled from '@emotion/styled';
import { BendHelpLineLinkWrapper } from 'components/_global/bend-help-line/BendHelpLineLink';
import { CalloutBox, CalloutHeader } from 'components/core/callout/Callout';
import { Text } from 'components/core/text/Text';
import { borderRadius, color } from 'components/core/theme';
import { BendHelpLine } from 'helpers/config/constants';

import PinkWink from './../../public/assets/img/buddies/Pink-HYP-Wink-1X.gif';

export interface Props {
  margin?: string;
  style?: CSSProperties;
}

const CalloutBoxNoGradient = styled(CalloutBox)<Props>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  padding: 0 20px;
  border-radius: ${borderRadius.m};
  background: ${color('tealLight')};
  ${props => props.margin && `margin: ${props.margin}`};
`;

const PinkWinkImg = styled.img`
  width: 92px;
  height: 80px;
`;

const CallForHelpWinkBox: FC<Props> = props => {
  const { margin, style } = props;
  return (
    <BendHelpLineLinkWrapper style={style}>
      <CalloutBoxNoGradient margin={margin}>
        <div>
          <p>
            <CalloutHeader>Having trouble with this step?</CalloutHeader>
          </p>
          <Text variant="text5" block as="p">
            Call us at {BendHelpLine.formattedNum} and we can help.
          </Text>
        </div>
        <PinkWinkImg src={PinkWink} />
      </CalloutBoxNoGradient>
    </BendHelpLineLinkWrapper>
  );
};

export default CallForHelpWinkBox;
